import React, { useEffect, useRef, useState } from "react";

const HtmlSimulations = ({ challenge, onComplete }) => {
    const iframeRef = useRef(null);
    const [targetUrl, setTargetUrl] = useState("/sense_hack.htm");
    const [isCompleted, setIsCompleted] = useState(false);

    useEffect(() => {
        let url = "/sense_hack.htm"; // Default

        if (challenge?.category === 'password_security') {
            url = "/password.htm";
        } else if (challenge?.category === 'data_protection') {
            url = "/sense_hack.htm";
        } else if ((challenge?.category === 'network_security') && (challenge?.id === '9376abd2-2aff-42c7-81d6-620a98cce638')) {
            url = "/network1.htm";
        } else if ((challenge?.category === 'network_security') && (challenge?.id === '71fca269-73a9-4932-af2c-5e847ec38918')) {
            url = "/network2.htm";
        } else if ((challenge?.category === 'network_security') && (challenge?.id === '761e6e5f-5ebf-46ef-a341-5c6c55f1bcb6')) {
            url = "/network3.htm";
        }

        setTargetUrl(url);
    }, [challenge]);

    // Poll for completion
    useEffect(() => {
        const checkCompletion = () => {
            if (isCompleted || !iframeRef.current) return;

            try {
                const iframeDocument = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
                if (!iframeDocument) return;

                // Check for winner section visibility
                const winnerSection = iframeDocument.querySelector('.winner-section');

                if (winnerSection) {
                    const style = window.getComputedStyle(winnerSection);
                    if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {

                        // Game is finished
                        const winnerMessage = winnerSection.querySelector('.winner-message')?.textContent || "";
                        const isSuccess = !winnerMessage.toLowerCase().includes('hacked');
                        const score = isSuccess ? 100 : 0;

                        finishSimulation(score, isSuccess);
                    }
                }
            } catch (e) {
                // Cross-origin errors might happen if not careful, but these are same-origin
                console.debug("Checking iframe status...", e);
            }
        };

        const timer = setInterval(checkCompletion, 1000);
        return () => clearInterval(timer);
    }, [isCompleted]);

    const finishSimulation = (score, isSuccess) => {
        if (isCompleted) return;
        setIsCompleted(true);

        onComplete({
            score: score,
            total: 100, // Assuming 100 is max score
            correct: isSuccess ? 1 : 0,
            incorrect: isSuccess ? 0 : 1,
            completed: true
        });
    };

    return (

        <div className="fixed inset-0 z-50 flex flex-col bg-gray-900">
            <div className="bg-gray-800 p-2 flex justify-between items-center text-sm text-gray-400 z-10">
                <span>Simulation Active</span>
                <button
                    onClick={() => finishSimulation(100, true)}
                    className="text-xs px-2 py-1 bg-gray-700 hover:bg-gray-600 rounded"
                >
                    Force Complete
                </button>
            </div>
            <iframe
                ref={iframeRef}
                src={targetUrl}
                title="Security Simulation"
                className="w-full h-full flex-grow border-0 bg-white"
                sandbox="allow-same-origin allow-scripts allow-forms"
            />
        </div>
    );

};

export default HtmlSimulations;